var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBookmark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.3894 5.60644L13.3838 5.60641M16.1497 1.42399L11.0967 1.0353C10.6487 1.00084 10.2081 1.16386 9.89034 1.48157L1.68426 9.68765C1.08319 10.2887 1.08319 11.2632 1.68426 11.8643L7.12591 17.306C7.72698 17.907 8.7015 17.907 9.30257 17.306L17.5086 9.09988C17.8264 8.78217 17.9894 8.34149 17.9549 7.8935L17.5662 2.84054C17.508 2.08363 16.9066 1.48221 16.1497 1.42399Z",
    stroke: "#3E3E64",
    strokeWidth: 1.74229,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookmark);
export default __webpack_public_path__ + "static/media/bookmark.73172cc7d4bcbac972dbb2aafe8706c4.svg";
export { ForwardRef as ReactComponent };